import { Directive, ElementRef } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { BINARY_ASSESSMENT_FNC_GROUPS, FncGroup } from '../../auth/FncGroup';
import { AbstractFncGroupVisibilityDirective } from './AbstractFncGroupVisibilityDirective';

@Directive({
  selector: '[digiresIsBinaryAssessment]'
})
export class IsBinaryAssessmentDirective extends AbstractFncGroupVisibilityDirective {

  constructor(element: ElementRef, authService: AuthService) {
    super(element, [
      FncGroup.IT_SUPPORT,
      ...BINARY_ASSESSMENT_FNC_GROUPS,
    ], authService);
  }

}
